import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";

function PoweredBy({ className }) {
    const intl = useIntl();
    return (
        <div
            className={classNames("ek-chat__by", {
                [className]: className,
            })}
        >
            <a
                href={intl.formatMessage({
                    id: "WEBMESSENGER.POWERED_BY.LINK",
                    defaultMessage: "https://www.ekonsilio.com",
                    description: "lien vers site eKonsilio",
                })}
                target="_blank"
                rel="noopener noreferrer"
            >
                <span>
                    <FormattedMessage
                        id="WEBMESSENGER.POWERED_BY.TEXT"
                        description="Texte : Powered by"
                        defaultMessage="Powered by"
                    />
                </span>
                <svg
                    style={{
                        marginBottom: "3px",
                    }}
                    viewBox="0 0 41 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g>
                        <path
                            d="M5.5713 5.87348C5.23554 6.94251 4.32937 7.66518 3.08682 7.66518C1.55907 7.66518 0.5 6.525 0.5 5.01788C0.5 3.51075 1.55907 2.37057 3.09619 2.37057C4.6333 2.37057 5.6724 3.50076 5.6724 4.97731C5.6724 5.10961 5.66241 5.24192 5.65243 5.37484H1.77313C1.89545 6.1387 2.39472 6.57618 3.08682 6.57618C3.60606 6.57618 4.04417 6.30159 4.25823 5.87348H5.57192H5.5713ZM1.76314 4.67152H4.44108C4.32937 3.92825 3.8195 3.44959 3.09681 3.44959C2.37412 3.44959 1.87485 3.91764 1.76314 4.67152Z"
                            fill="white"
                        />
                        <path
                            d="M6.5386 0.435946H7.75057V3.41962C8.01518 3.4502 8.26981 3.49076 8.50447 3.54194L10.8154 0.43657H12.3226L9.69522 3.93947C10.8666 4.51985 11.5993 5.60948 12.4649 7.56469H11.1312C10.1233 5.49777 9.56353 4.82565 7.7512 4.57103V7.56469H6.53923V0.435946H6.5386Z"
                            fill="white"
                        />
                        <path
                            d="M14.7758 2.37057C16.3136 2.37057 17.362 3.50076 17.362 5.01788C17.362 6.53499 16.3136 7.66518 14.7758 7.66518C13.2381 7.66518 12.1797 6.525 12.1797 5.01788C12.1797 3.51075 13.2281 2.37057 14.7758 2.37057ZM13.4116 5.01788C13.4116 5.8223 13.9614 6.43327 14.7758 6.43327C15.5903 6.43327 16.1301 5.8223 16.1301 5.01788C16.1301 4.21345 15.5803 3.5925 14.7758 3.5925C13.9714 3.5925 13.4116 4.20347 13.4116 5.01788Z"
                            fill="white"
                        />
                        <path
                            d="M37.9138 2.37057C39.4516 2.37057 40.5 3.50076 40.5 5.01788C40.5 6.53499 39.4516 7.66518 37.9138 7.66518C36.3761 7.66518 35.3177 6.525 35.3177 5.01788C35.3177 3.51075 36.3661 2.37057 37.9138 2.37057ZM36.5496 5.01788C36.5496 5.8223 37.0994 6.43327 37.9138 6.43327C38.7283 6.43327 39.2681 5.8223 39.2681 5.01788C39.2681 4.21345 38.7183 3.5925 37.9138 3.5925C37.1094 3.5925 36.5496 4.20347 36.5496 5.01788Z"
                            fill="white"
                        />
                        <path
                            d="M22.7591 7.56345H21.5371V5.01788C21.5371 4.22406 21.0791 3.5925 20.3657 3.5925C19.6524 3.5925 19.1943 4.18287 19.1943 5.01788V7.56345H17.9724V5.01788C17.9724 3.50076 19.0009 2.37057 20.3651 2.37057C21.7294 2.37057 22.7579 3.50076 22.7579 5.01788V7.56345H22.7591Z"
                            fill="white"
                        />
                        <path
                            d="M25.6717 7.66518C24.3074 7.66518 23.4113 6.97308 23.3195 5.94399H24.5315C24.6026 6.41205 25.0102 6.66729 25.6411 6.66729C26.1298 6.66729 26.395 6.41267 26.395 6.11749C26.395 5.09963 23.473 5.83229 23.473 3.92825C23.473 3.06267 24.2163 2.37057 25.4788 2.37057C26.7414 2.37057 27.4946 3.12445 27.617 4.13232H26.405C26.3338 3.68424 26.0181 3.36846 25.4277 3.36846C25.0102 3.36846 24.7044 3.60249 24.7044 3.90828C24.7044 4.88557 27.6369 4.1629 27.6369 6.1281C27.6369 7.01365 26.8531 7.6658 25.6717 7.6658V7.66518Z"
                            fill="white"
                        />
                        <path
                            d="M29.103 0.334199C29.5105 0.334199 29.7851 0.608789 29.7851 1.02629C29.7851 1.41321 29.5105 1.69841 29.103 1.69841C28.6955 1.69841 28.4209 1.41321 28.4209 1.02629C28.4209 0.608789 28.6955 0.334199 29.103 0.334199ZM28.4814 2.47226H29.7234V7.56342H28.4814V2.47226Z"
                            fill="white"
                        />
                        <path
                            d="M30.8847 0.435946H32.0967V7.56344H30.8847V0.435946Z"
                            fill="white"
                        />
                        <path
                            d="M33.8885 0.334199C34.296 0.334199 34.5706 0.608789 34.5706 1.02629C34.5706 1.41321 34.296 1.69841 33.8885 1.69841C33.481 1.69841 33.2064 1.41321 33.2064 1.02629C33.2064 0.608789 33.481 0.334199 33.8885 0.334199ZM33.2675 2.47226H34.5095V7.56342H33.2675V2.47226Z"
                            fill="white"
                        />
                    </g>
                </svg>
                <svg viewBox="0 0 24 24" version="1.1">
                    <g
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <path
                            d="M14.0069431,7.00607258 C13.4546584,7.00607258 13.0069431,6.55855153 13.0069431,6.00650634 C13.0069431,5.45446114 13.4546584,5.00694009 14.0069431,5.00694009 L15.0069431,5.00694009 C17.2160821,5.00694009 19.0069431,6.7970243 19.0069431,9.00520507 L19.0069431,15.001735 C19.0069431,17.2099158 17.2160821,19 15.0069431,19 L3.00694311,19 C0.797804106,19 -0.993056895,17.2099158 -0.993056895,15.001735 L-0.993056895,8.99826498 C-0.993056895,6.7900842 0.797804106,5 3.00694311,5 L4.00694793,5 C4.55923268,5 5.00694793,5.44752105 5.00694793,5.99956624 C5.00694793,6.55161144 4.55923268,6.99913249 4.00694793,6.99913249 L3.00694311,6.99913249 C1.90237361,6.99913249 1.00694311,7.89417459 1.00694311,8.99826498 L1.00694311,15.001735 C1.00694311,16.1058254 1.90237361,17.0008675 3.00694311,17.0008675 L15.0069431,17.0008675 C16.1115126,17.0008675 17.0069431,16.1058254 17.0069431,15.001735 L17.0069431,9.00520507 C17.0069431,7.90111468 16.1115126,7.00607258 15.0069431,7.00607258 L14.0069431,7.00607258 Z"
                            fill="#000000"
                            fillRule="nonzero"
                            opacity="0.3"
                            transform="translate(9.006943, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-9.006943, -12.000000) "
                        />
                        <rect
                            fill="#000000"
                            opacity="0.8"
                            transform="translate(14.000000, 12.000000) rotate(-270.000000) translate(-14.000000, -12.000000) "
                            x="13"
                            y="6"
                            width="2"
                            height="12"
                            rx="1"
                        />
                        <path
                            d="M21.7928932,9.79289322 C22.1834175,9.40236893 22.8165825,9.40236893 23.2071068,9.79289322 C23.5976311,10.1834175 23.5976311,10.8165825 23.2071068,11.2071068 L20.2071068,14.2071068 C19.8165825,14.5976311 19.1834175,14.5976311 18.7928932,14.2071068 L15.7928932,11.2071068 C15.4023689,10.8165825 15.4023689,10.1834175 15.7928932,9.79289322 C16.1834175,9.40236893 16.8165825,9.40236893 17.2071068,9.79289322 L19.5,12.0857864 L21.7928932,9.79289322 Z"
                            fill="#000000"
                            fillRule="nonzero"
                            transform="translate(19.500000, 12.000000) rotate(-90.000000) translate(-19.500000, -12.000000) "
                        />
                    </g>
                </svg>
            </a>
        </div>
    );
}

PoweredBy.propTypes = {
    className: PropTypes.string,
};

PoweredBy.defaultProps = {
    className: "",
};

export default PoweredBy;
